import request from '@/utils/request'

export function getOpenAIModelOptions() {
  return request({
    url: '/openai/GetModelOptions',
    method: 'get',
  })
}

export function getOpenAIModelSetting() {
  return request({
    url: '/openai/GetModelSetting',
    method: 'get',
  })
}

export function saveOpenAIModelSetting(data) {
  return request({
    url: '/openai/SaveModelSetting',
    method: 'post',
    data,
  })
}

export function deleteOpenAIModelSetting(id) {
  return request({
    url: '/openai/DeleteModelSetting',
    method: 'delete',
    params: {
      id,
    },
  })
}
